import { usePremiumPageCopy } from '@src/pages/PremiumPage/copy';
import { useTranslation } from 'react-i18next';
import { ParticipantFace } from '@src/components/faces/ParticipantFace';
import { Panel, Typography } from '@src/components';
import { ActivityEventIcon } from '../BoxPage/ActivityEventIcon';
import { presentActivity, type Activity } from '../BoxPage/activityPresentation';



/** Static examples use the live history formatter, identity markup and row styles. */
export function HistoryExample() {
  const copy = usePremiumPageCopy();
  const events: Activity[] = [
    { id: 1, type: 'participant.joined', cardId: 1, participantName: copy.olivia, participantPicture: 'rabbit', createdAt: '2026-10-15T14:30:00', metadata: {} },
    { id: 2, type: 'box.settings_updated', actorType: 'organizer', actorCardId: 2, participantName: null, createdAt: '2026-10-15T12:15:00', metadata: { actor: { name: copy.alex, pictureId: null, avatar: null }, before: { useWish: false }, after: { useWish: true } } },
    { id: 3, type: 'message.sent', cardId: 3, participantName: copy.michael, participantPicture: 'bear', createdAt: '2026-10-14T18:00:00', metadata: { direction: 'santa', senderName: copy.michael } },
  ];
  const { t, i18n } = useTranslation();
  return <Panel bordered padding="medium" className="box-activity">
    <Typography as="p" role="meta/helper">{copy.exampleGameHistory}</Typography>
    <ol className="box-activity__list">{events.map(event => {
      const presentation = presentActivity(event, t, (_field, value) => String(value ?? '—'), name => <span className="box-activity__person"><span className="box-activity__pairing-avatar" aria-hidden="true"><ParticipantFace picture={event.participantPicture || 'fox'} /></span><b>{name}</b></span>, 2);
      return <li key={event.id}><span className="box-activity__avatar" aria-hidden="true"><ActivityEventIcon type={event.type} /></span><div><strong className="box-activity__title-regular">{presentation.title}</strong><time dateTime={event.createdAt}>{new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(event.createdAt))}</time></div></li>;
    })}</ol>
  </Panel>;
}
